import React, { useRef } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined';

function ImageUpload({ label, value, onChange, error, helperText, name }) {
    const theme = useTheme();
    const inputRef = useRef();

    const handleFileChange = (event) => {
        if (onChange) {
            const file = event.target.files[0];
            onChange(file);
        }
    };

    const handleButtonClick = () => {
        inputRef.current.click();
    };

    return (
        <Box>
            <Typography
                style={{
                    color: theme.palette.text.primary,
                    fontSize: 13,
                    marginTop: 24,
                    marginBottom: 4,
                }}
            >
                {label}
            </Typography>
            <input
                type="file"
                ref={inputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept="image/*"
            />
            <Button
                variant="outlined"
                fullWidth
                onClick={handleButtonClick}
                sx={{
                    backgroundColor: theme.palette.customGrey.insideInput,
                    textTransform: 'none',
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '10px 12px',
                    borderColor: error ? theme.palette.error.main : theme.palette.customGrey.borderInput,
                    color: theme.palette.text.secondary,
                    '&:hover': {
                        borderColor: theme.palette.customGrey.borderInput,
                    },
                    '& .MuiSvgIcon-root': {
                        color: theme.palette.text.secondary,
                    },
                }}
            >
                {value ? value.name : <>{name} <DriveFolderUploadOutlinedIcon /></>}
            </Button>
            {helperText && (
                <Typography
                    style={{
                        color: error ? theme.palette.error.main : theme.palette.text.secondary,
                        fontSize: 12,
                        marginTop: 4,
                    }}
                >
                    {helperText}
                </Typography>
            )}
        </Box>
    );
}

export default ImageUpload;
